import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import classNames from 'classnames'
import { hideNotification } from '@/state/actions/notification'
import ClickAwayListener from '@/ui/ClickAwayListener'
import compose from 'recompose/compose'

import translate from '@/i18n/translate'

class Snackbar extends React.Component {
  static propTypes = {
    theme: PropTypes.object.isRequired,
  }

  state = {
    snack: null,
    visible: false,
  }

  componentDidMount() {
    if (this.props.snack) {
      this.showSnack(this.props.snack)
    }
  }

  componentWillReceiveProps(nextProps) {
    const snack = this.props.snack
    const nextSnack = nextProps.snack
    const visibleSnack = this.state.snack
    const isInactive = this.props.inactive
    const willInactivate = nextProps.inactive
    if (
      !willInactivate &&
      ((nextSnack && !snack) || (nextSnack && nextSnack.id !== (snack || {}).id))
    ) {
      this.showSnack(nextSnack) // Active, and a new snack stands in line in the queue. Show it!
    } else if (isInactive && !willInactivate && (snack && !visibleSnack)) {
      this.showSnack(snack) // Will be active, and we have a snack. Show it!
    } else if (!isInactive && willInactivate && visibleSnack) {
      this.hideSnack() // Will deactivate, remove the snack until we become active again
    } else if (!nextSnack && snack) {
      this.hideSnack() // The current snack has been removed from the queue, no one stands in line. Hide it!
    }
  }

  componentWillUnmount() {
    this.clearDismissTimer()
  }

  showSnack = snack => {
    this.hideSnack().then(() => {
      this.setState({ snack, visible: false })
      setTimeout(() => {
        this.setState({ visible: true })
        if (snack.data.timeout) {
          this.snackTimer = setTimeout(() => {
            this.props.dispatch(hideNotification(snack.id))
          }, snack.data.timeout)
        }
      }, 1)
    })
  }

  hideSnack = () => {
    if (!this.state.snack) {
      return Promise.resolve()
    }
    return new Promise(resolve => {
      this.clearDismissTimer()
      this.setState({ visible: false })
      this.afterTransition = () => {
        this.setState({ snack: null })
        resolve()
      }
    })
  }

  clearDismissTimer = () => {
    if (this.snackTimer) {
      clearTimeout(this.snackTimer)
      this.snackTimer = null
    }
  }

  transitionEndHandler = () => {
    if (this.afterTransition) {
      this.afterTransition()
      this.afterTransition = null
    }
  }

  buttonClickHandler = () => {
    const { onButtonClick } = this.props
    const { snack } = this.state
    const { id, data: { button = {} } } = snack

    if (onButtonClick) {
      onButtonClick(snack)
    } else if (button.action && typeof button.action === 'function') {
      button.action(snack)
    } else if (button.action === 'redirect' && button.href) {
      window.location.href = button.href
    }

    this.props.dispatch(hideNotification(id))
  }

  render() {
    const { snack } = this.state
    if (!snack) {
      return null
    }
    const { theme, translate } = this.props
    const button = (snack.data.button || {}).text ? snack.data.button : null
    const largeScreen = window.matchMedia('(min-width: 720px)').matches
    return (
      <ClickAwayListener onClickAway={this.buttonClickHandler}>
        <div
          className={classNames(theme['notification'], {
            [theme['notification-large']]: largeScreen,
            [theme['notification-visible']]: this.state.visible,
          })}
          onTransitionEnd={this.transitionEndHandler}
        >
          <span className={theme['notification-label']}>
            {snack.text.startsWith('i18n.') ? translate(snack.text) : snack.text}
          </span>
          <If condition={button}>
            <button className={theme['notification-button']} onClick={this.buttonClickHandler}>
              {button.label}
            </button>
          </If>
        </div>
      </ClickAwayListener>
    )
  }
}

// export default connect(state => ({ snack: state.ui.notification.queue[0] || null }))(Snackbar)

function mapStateToProps(state, props) {
  return { snack: state.ui.notification.queue[0] || null }
}

const enhance = compose(connect(mapStateToProps), translate)

export default enhance(Snackbar)



// WEBPACK FOOTER //
// ./ui/Notification/Snackbar.js